import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export type ItemPayload = {
  item: PapiDeviation | undefined;
};

export const pinPostOnFeed = createAction(
  'POSTS_PIN_POST_ON_FEED',
  (payload: ItemPayload) => payload
);

export const featurePost = createAction(
  'POSTS_FEATURE_ITEM',
  (payload: ItemPayload) => payload
);

export const unfeaturePost = createAction(
  'POSTS_UNFEATURE_ITEM',
  (payload: ItemPayload) => payload
);

export const pinPost = createAction(
  'POSTS_PIN_ITEM',
  (payload: { item: PapiDeviation; streamId: string }) => payload
);

export const unpinPost = createAction(
  'POSTS_UNPIN_ITEM',
  (payload: { streamId: string }) => payload
);
